import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Card,
    CardBody,
    Row,
    Col,
    Badge,
    Button,
    Table,
    Spinner,
} from "reactstrap";

import { toast } from "react-toastify";
import { deleteFollowUpApi, getEnquiryDetailsApi, } from "../../../api/apiUrlConst";
import AddFollowUpModal from "./AddFollowUpModal";
import AddPaymentModal from "./AddPaymentModal";
import EditEnquiryModal from "./EditEnquiryModal";
import { useTheme } from "@emotion/react";

const getStatusColor = (status: string) => {
    switch (status) {
        case "Joined": return "success";
        case "InFollowUp": return "warning";
        case "NotInterested": return "danger";
        case "Assigned": return "primary";
        case "DND": return "dark";
        default: return "secondary";
    }
};

const EnquiryDetails = () => {
    const { eid } = useParams();
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [followUpModal, setFollowUpModal] = useState(false);
    const [paymentModal, setPaymentModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const theme = useTheme();
    const isDark = theme === "dark";
    const navigate = useNavigate();
    const [editFollowUp, setEditFollowUp] = useState<any>(null);


    const loadDetails = async () => {
        try {
            const res = await getEnquiryDetailsApi(eid);
            setData(res);
        } catch {
            toast.error("Failed to load enquiry details");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadDetails();
        // eslint-disable-next-line
    }, []);

    if (loading) return <Spinner className="mt-5" />;

    if (!data) return <div>No Data Found</div>;

    const { enquiry, followUps, fees, payments } = data;

// eslint-disable-next-line
    const courseOptions: { [key: string]: string[] } = {
        "AI ML": [
            "Artificial Intelligence",
            "Data Science",
            "Machine Learning",
        ],
        "Programming": [

            "Python Programming",
            "C++",
            "C#.Net",
            "Java",
        ],
        "CAD Automation": [
            "C++ & Creo Toolkit",
            "C++ & CATIA CAA",
            "",
            "C#.Net & Solidworks API",
            "C#.Net & Nx Customization",
            "C#.Net & Autodesk Inventor API",
            "C#.Net & AutoCAD API",
            "C#.Net & Solid Edge API",
            "C#.Net & Revit API",
            "",
            "Python & CATIA CAA",
            "Python & Nx Customization",
            "",
            "NX Customization",
            "SolidWorks API",
            "CATIA CAA",
            "Creo Toolkit",
            "Revit API",
            "AutoCAD API",
            "Solid Edge API",
            "Autodesk Inventor API",
        ],
        "PLM Automation": [
            "Java & Windchill",
            "C++ & Team center",
            "Windchill",
            "Teamcenter",
        ],
    };

    const handleDeleteFollowUp = async (id: number) => {
        if (!window.confirm("Delete this follow up?")) return;

        try {
            await deleteFollowUpApi(id);

            toast.success("Follow Up Deleted");

            loadDetails();
        } catch {
            toast.error("Delete failed");
        }
    };
    return (
        <div style={{ background: "#f4f6fb", minHeight: "100vh" }}>


            {/* ===== HEADER ===== */}
            <div
                className="p-4 mb-4"
                style={{
                    background: "linear-gradient(90deg, #374151, #093d92)",
                    borderRadius: "16px",
                    color: "#fff",
                }}
            >
                <div className="d-flex justify-content-between align-items-center">

                    {/* Left Side */}
                    <div>
                        <h3 className="fw-bold mb-1">Enquiry Details</h3>
                        <small>Complete enquiry profile & financial summary</small>
                    </div>

                    {/* Right Side */}
                    <Button
                        color={isDark ? "secondary" : "light"}
                        className="shadow-sm rounded-pill px-4"
                        onClick={() => navigate(-1)}
                    >
                        ← Back
                    </Button>

                </div>
            </div>

            {/* ================= Overview ================= */}
            <Card
                className="border-0 shadow-sm mb-4"
                style={{ borderRadius: "16px" }}
            >
                <CardBody>
                    <Row className="align-items-center">

                        <Col md={6}>
                            <h4 className="fw-bold mb-1">{enquiry.name}</h4>
                            <p className="text-muted mb-1">{enquiry.email}</p>
                            <p className="text-muted mb-0">{enquiry.phoneNumber}</p>
                        </Col>

                        <Col md={6} className="text-md-end">
                            <Badge
                                style={{
                                    padding: "6px 14px",
                                    fontSize: "12px",
                                    borderRadius: "20px",
                                }}
                                color={getStatusColor(enquiry.status)}
                            >
                                {enquiry.status}
                            </Badge>

                            <div className="mt-2">
                                <Button
                                    size="sm"
                                    className="rounded-pill"
                                    color="warning"
                                    onClick={() => setEditModal(true)}
                                >
                                    ✏ Edit Enquiry
                                </Button>
                            </div>

                            <div className="mt-3">
                                <div><strong>EID:</strong> {enquiry.eid}</div>
                                <div><strong>Coordinator:</strong> {enquiry.coordinatorName}</div>
                            </div>
                        </Col>

                    </Row>

                    <hr />

                    <Row>
                        <Col md={6}>
                            <strong>Course:</strong> {enquiry.courseCategory} - {enquiry.courseName}
                        </Col>
                        <Col md={6}>
                            <strong>Submitted:</strong>{" "}
                            {new Date(enquiry.submittedAt).toLocaleDateString()}
                        </Col>
                    </Row>

                    <Row className="mt-3">
                        <Col>
                            <strong>Message:</strong>
                            <p className="text-muted">{enquiry.message}</p>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* ================= FollowUps ================= */}
            <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: "16px" }}>
                <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="fw-semibold mb-0">Follow Ups</h5>
                        <Button
                            size="sm"
                            className="rounded-pill"
                            style={{
                                background: "#667eea",
                                border: "none"
                            }}
                            onClick={() => {
                                setEditFollowUp(null);
                                setFollowUpModal(true);
                            }}
                        >
                            + Add FollowUp
                        </Button>
                    </div>

                    <Table
                        responsive
                        hover
                        className="align-middle"
                        style={{ borderCollapse: "separate", borderSpacing: "0 8px" }}
                    >
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Interest</th>
                                <th>Status</th>
                                <th>Next Contact</th>
                                <th>Message</th>
                                <th style={{ width: "160" }} >Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {followUps?.length === 0 && (
                                <tr>
                                    <td colSpan={5} className="text-center text-muted">
                                        No followups yet
                                    </td>
                                </tr>
                            )}

                            {followUps?.map((f: any) => (
                                <tr key={f.id}>
                                    <td>
                                        {new Date(f.followUpDate).toLocaleDateString()}
                                    </td>

                                    <td>
                                        <Badge color="primary">
                                            {f.interestLevel}
                                        </Badge>
                                    </td>

                                    <td>
                                        <Badge color="info">
                                            {f.responseStatus}
                                        </Badge>
                                    </td>

                                    <td>
                                        {f.nextContactDate
                                            ? new Date(f.nextContactDate).toLocaleDateString()
                                            : "-"}
                                    </td>

                                    <td style={{ maxWidth: 300 }}>
                                        {f.message}
                                    </td>

                                    <td>
                                        <div className="d-flex gap-2">
                                            <Button
                                                color="warning"
                                                size="sm"
                                                className="rounded-pill"
                                                onClick={() => {
                                                    setEditFollowUp(f);
                                                    setFollowUpModal(true);
                                                }}
                                            >
                                                ✏ Edit
                                            </Button>

                                            <Button
                                                color="danger"
                                                size="sm"
                                                className="rounded-pill"
                                                onClick={() => handleDeleteFollowUp(f.id)}
                                            >
                                                🗑 Delete
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </CardBody>
            </Card>

            {/* ================= Fees ================= */}
            {fees && (
                <Card className="shadow-sm border-0 rounded-4 mb-4">
                    <CardBody>
                        <h5 className="fw-semibold mb-3">Fees Summary</h5>

                        <Row className="text-center">
                            <Col md={3}>
                                <div className="text-muted">Total</div>
                                <h5 className="fw-bold">₹ {fees.totalFees}</h5>
                            </Col>

                            <Col md={3}>
                                <div className="text-muted">Paid</div>
                                <h5 className="fw-bold text-success">
                                    ₹ {fees.paidAmount}
                                </h5>
                            </Col>

                            <Col md={3}>
                                <div className="text-muted">Pending</div>
                                <h5 className="fw-bold text-danger">
                                    ₹ {fees.pendingAmount}
                                </h5>
                            </Col>

                            <Col md={3}>
                                <div className="text-muted">Status</div>
                                <h6>
                                    {fees.isFullyPaid ? (
                                        <Badge color="success">Fully Paid</Badge>
                                    ) : (
                                        <Badge color="warning">Pending</Badge>
                                    )}
                                </h6>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            )}

            {/* ================= Payments ================= */}
            {payments?.length > 0 && (
                <Card className="border-0 shadow-sm" style={{ borderRadius: "16px" }}>
                    <CardBody>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="fw-semibold mb-0">Payment History</h5>

                            {fees.pendingAmount > 0 && (
                                <>
                                    <Col md={3}>
                                    </Col>

                                    <Col md="auto" className="d-flex align-items-end">
                                        <Button
                                            size="sm"
                                            className="rounded-pill px-3"
                                            style={{
                                                background: "#20c997",
                                                border: "none"
                                            }}
                                            onClick={() => setPaymentModal(true)}
                                        >
                                            + Add Payment
                                        </Button>
                                    </Col>
                                </>
                            )}
                        </div>

                        <Table
                            responsive
                            hover
                            className="align-middle"
                            style={{ borderCollapse: "separate", borderSpacing: "0 8px" }}
                        >
                            <thead>
                                <tr style={{ background: "#f4f6fb" }}>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Mode</th>
                                    <th>Transaction Id</th>
                                    <th>Account</th>
                                </tr>
                            </thead>

                            <tbody>
                                {payments.map((p: any, index: number) => (
                                    <tr key={index} style={{ background: "#fff" }}>
                                        <td>{new Date(p.paidDate).toLocaleDateString()}</td>
                                        <td className="fw-semibold text-success">
                                            ₹ {p.amount}
                                        </td>
                                        <td>{p.mode}</td>
                                        <td>{p.transactionId}</td>
                                        <td>
                                            {p.account ? (
                                                <span className="badge bg-light text-dark px-3 py-2 rounded-pill">
                                                    {p.account}
                                                </span>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            )}

            <AddFollowUpModal
                isOpen={followUpModal}
                toggle={() => {
                    setFollowUpModal(false);
                    setEditFollowUp(null);
                }}
                enqFormId={enquiry.id}
                onSuccess={loadDetails}
                editData={editFollowUp}
            />

            {fees && (
                <AddPaymentModal
                    isOpen={paymentModal}
                    toggle={() => setPaymentModal(!paymentModal)}
                    enqFormId={enquiry.id}
                    pendingAmount={fees.pendingAmount}
                    onSuccess={loadDetails}
                />
            )}
            <EditEnquiryModal
                isOpen={editModal}
                toggle={() => setEditModal(!editModal)}
                enquiry={enquiry}
                onSuccess={loadDetails}
            />

        </div>
    );
};

export default EnquiryDetails;